module.exports = __webpack_public_path__ + "static/media/emay.logo-l.4c159111.png";